import { useQuery } from '@tanstack/react-query';
import { catalogService } from '../../shared/services';
import { Award, BookOpen, TrendingUp } from 'lucide-react';
import { Link } from 'react-router-dom';

export function TracksPage() {
  const { data: trilhas, isLoading } = useQuery({
    queryKey: ['trilhas'],
    queryFn: catalogService.getTrilhas,
  });

  return (
    <div className="p-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Trilhas de Aprendizado</h1>
          <p className="text-gray-600 mt-2">
            Jornadas estruturadas para desenvolver suas habilidades
          </p>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-12">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600"></div>
          </div>
        ) : (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            {trilhas?.map((trilha) => (
              <Link
                key={trilha.id}
                to={`/trilhas/${trilha.id}`}
                className="card hover:shadow-lg transition-shadow group"
              >
                <div className="flex gap-6">
                  {/* Imagem */}
                  <div className="w-48 h-32 bg-gradient-to-br from-primary-100 to-primary-200 rounded-lg overflow-hidden flex-shrink-0">
                    <div className="w-full h-full flex items-center justify-center">
                      <Award size={48} className="text-primary-600" />
                    </div>
                  </div>

                  {/* Conteúdo */}
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 mb-2">
                      <span className="px-2 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded">
                        {trilha.totalCursos || 0} curso{trilha.totalCursos !== 1 ? 's' : ''}
                      </span>
                      {trilha.progresso !== undefined && trilha.progresso > 0 && (
                        <span className="px-2 py-1 bg-green-100 text-green-700 text-xs font-medium rounded">
                          {trilha.progresso}% concluído
                        </span>
                      )}
                    </div>

                    <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-primary-600 transition-colors">
                      {trilha.nome}
                    </h3>

                    <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                      {trilha.descricao}
                    </p>

                    <div className="flex items-center gap-4 text-sm text-gray-500">
                      <div className="flex items-center gap-1">
                        <BookOpen size={16} />
                        <span>{trilha.totalCursos || 0} cursos</span>
                      </div>
                      
                      {trilha.progresso !== undefined && (
                        <div className="flex items-center gap-2 flex-1">
                          <TrendingUp size={16} />
                          <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden max-w-xs">
                            <div
                              className="h-full bg-primary-600 transition-all"
                              style={{ width: `${trilha.progresso}%` }}
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
